import { render, staticRenderFns } from "./userNotificationBox.vue?vue&type=template&id=6dbf8ab6&"
import script from "./userNotificationBox.vue?vue&type=script&lang=js&"
export * from "./userNotificationBox.vue?vue&type=script&lang=js&"
import style0 from "./userNotificationBox.vue?vue&type=style&index=0&id=6dbf8ab6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports